<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/LJsv1/tc-custom/9781788851749.jpg?1702083600187" alt="This image is the cover for the book Murder in the Merchant City"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Murder in the Merchant City
      </h1>
      <p class="bookDescription body article font2">
        <b>In Glasgow, a single mom with a secret life gets caught up in murder:</b><b> “A gripping whodunit [with] a good measure of comedy” (<i>Scottish Field</i>).</b><br/>  <br/> Annette Somerville, a young single mother, earns her living giving men massages—along with a few extra services—at a high-class Glasgow sauna, scrupulously keeping her respectable home life separate from her professional activities. Then, during a series of seemingly unconnected murders in the city, Annette realizes that all the victims have been regular customers.<br/>  <br/> No one else seems interested, and her boss makes it clear that going to the police will cost Annette her job. But Annette’s new boyfriend, a former customer of the sauna, could be the murderer’s next victim . . .<br/>  <br/> This is a unique and witty crime thriller from the author of <i>Close Quarters</i>, praised as “excellent reading” by <i>Scots Magazine</i>.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Angus McAllister
      </h2>
      
      <p class="authorDescription body article">Angus McAllister worked as a solicitor and university professor, and is now retired. For many years he wrote academic books and articles, as well as fiction. He is the author of the bestselling Close Quarters, and he lives in Glasgow.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Polygon
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4de851a3